import { useLocation } from 'react-router-dom';

const withLocation = (Component) => (props) => {
  const { pathname } = useLocation();

  return <Component {...props} pathname={pathname} />;
};

export default withLocation;
